module.exports = __webpack_public_path__ + "static/media/no-posts.ab3d545e.png";